import { render, staticRenderFns } from "./CustomSMSButton.vue?vue&type=template&id=6139c5fc&"
import script from "./CustomSMSButton.vue?vue&type=script&lang=js&"
export * from "./CustomSMSButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports